/**
 * 自营摄影子类
 */
export const SELF_PHOTO_TYPE_ENUM = {
  /**
   * 普通自营摄影
   */
  NORMAL: 1,
  /**
   * 二销扫码付
   */
  SCAN_BUY: 2,
  /**
   * 云摄影
   */
  CLOUD: 3
}

/**
 * 普通自营摄影是否支持预约,默认1
 */
export const SELF_PHOTO_NORMAL_SUPORRT_RESERVE_ENUM = {
  /**
   * 是
   */
  YES: 1,
  /**
   * 否
   */
  NO: 0
}

/**
 * 自营摄影-云摄影状态
 */
export const CLOUD_PHOTO_STATE_ENUM = {
  /**
   * 下单成功，母单已支付
   */
  STEP1_PAIED_INIT: 1,
  /**
   * 预约拍摄，待预约，改预约
   */
  STEP2_RESERVE_STAGE: 2,
  /**
   * 现场拍摄
   */
  STEP3_PHOTO_TAKING_STAGE: 3,
  /**
   * 挑选精修照片
   */
  STEP4_CHOOSE_REPAIR_PHOTO_STAGE: 4,
  /**
   * 修图师修片
   */
  STEP5_REPAIR_STAGE: 5,
  /**
   * 交付精修照片
   */
  STEP6_REPAIR_COMPLETE: 6
}
